import {adapterForApi} from 'Utils/rtkq.utils';
import {dcpcApi} from './dcpcApi';
import axios from "axios";
import {hostWithPrefix} from "../../Features/Constructor/common/ApiCommon";

const REPORTS_INVALIDATE_TAG = 'REPORTS';

dcpcApi.enhanceEndpoints({ addTagTypes: [REPORTS_INVALIDATE_TAG] });
const reportsApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getReportsList: builder.query({
      query: () => ({
        url: 'v2/reports',
        method: 'GET',
      }),
      transformResponse(result) {
        // TODO. Почему вообще приходит пустой репорт?
        return result?.filter((report) => report.report);
      },
      providesTags: [REPORTS_INVALIDATE_TAG],
    }),

    updateReport: builder.mutation({
      query: (report) => ({
        url: 'v2/reports',
        method: 'POST',
        body: report,
      }),
      invalidatesTags: [REPORTS_INVALIDATE_TAG],
    }),

    deleteReport: builder.mutation({
      query: (id) => ({
        url: `v2/reports/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [REPORTS_INVALIDATE_TAG],
    }),

    postTableDataTS: builder.mutation({
      query: (data) => ({
        url: '/dv-time-series/table',
        method: 'POST',
        body: data,
      }),
    }),

    formingReportCSV: builder.mutation({
      query: ({ body, args }) => ({
        method: 'POST',
        url: 'dv-time-series/csv',
        body,
        params: {
          timeZone: body.timezone === undefined ? 0 : body.timezone,
        },
      }),
      // async onQueryStarted(_, { queryFulfilled }) {
      //     try {
      //         await queryFulfilled;
      //     } catch (err) {
      //         toaster.danger('Произошла ошибка при формировании CSV');
      //     }
      // },
    }),

    pullDatasourceTS: builder.mutation({
      query: (body) => ({
        url: 'dv-time-series/charts',
        method: 'POST',
        body,
      }),
    }),

    pullDatasourceTS2: builder.query({
      query: (body) => ({
        url: 'dv-time-series/charts',
        method: 'POST',
        body,
      }),
    }),

    // from Utils/Network/url.js
    // запрос на создание/изменение значения кода
    updateReportCodeValue: builder.mutation({
      query: ({ valueId, report, codeId }) => ({
        url: `editdatavalue${valueId ? `/${valueId}` : ''}?deviceCodeId=${codeId}`,
        method: valueId ? 'PUT' : 'POST',
        body: report,
      }),
      invalidatesTags: [REPORTS_INVALIDATE_TAG],
    }),

    getDatasourceDeviceCodeUnique: builder.query({
      query: (datasourceId) => ({
        url: `datasource/${datasourceId}/devicecodes/unique`,
        method: 'GET',
      }),
      providesTags: [REPORTS_INVALIDATE_TAG],
    }),

    getDvTimeSeriesLogs: builder.mutation({
      query: (body) => ({
        url: '/dv-time-series/logs',
        method: 'POST',
        body,
      }),
    }),
    getLastDataValues: builder.query({
      query: (body) => ({
        url: '/dv-time-series/values',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetReportsListQuery,
  // useGetReportQuery,
  usePostTableDataTSMutation,
  useUpdateReportMutation,
  useDeleteReportMutation,

  useFormingReportCSVMutation,
  useUpdateReportCodeValueMutation,

  useGetDatasourceDeviceCodeUniqueQuery,

  usePullDatasourceTSMutation,
  usePullDatasourceTS2Query,
  useLazyPullDatasourceTS2Query,

  useGetDvTimeSeriesLogsMutation,
  useLazyGetLastDataValuesQuery,
} = adapterForApi(reportsApi);

export { reportsApi };

// export const invalidateReports = () => invalidateTags([REPORTS_INVALIDATE_TAG]);

export const reportsSelect = reportsApi.endpoints.getReportsList.select();

export function formingReportCsvZip(reportIds, timezone, userName) {
    let host = hostWithPrefix
    if (!host.endsWith('/')) {
        host = host + '/'
    }
    return  axios({
        url: 'http://' + host + 'dv-time-series/csvZip?' +
            'userName=' + userName +
            '&reportIds=' + reportIds +
            '&timeZone=' + timezone,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: 'json',
    })
}
